import { z } from "zod";
import { TimestampSchema } from "./common.js";
import { IdSchema } from "./ids.js";
export const JobStatusSchema = z.enum([
    "queued",
    "running",
    "retrying",
    "succeeded",
    "failed",
    "cancelled",
]);
/** Keys that concurrency limits apply to (per company, per connection, per sandbox type). */
export const ConcurrencyKeysSchema = z.object({
    companyId: IdSchema,
    connectionId: IdSchema.optional(),
    sandboxType: z.string().optional(),
});
export const RetryPolicySchema = z.object({
    maxAttempts: z.number().int().positive(),
    backoffMs: z.number().int().nonnegative(),
    /** Multiplier per attempt (exponential backoff). */
    factor: z.number().min(1),
});
export const JobSchema = z.object({
    id: IdSchema,
    /** Handler name, e.g. "orchestrator.workerRun". */
    kind: z.string().min(1),
    taskId: IdSchema.nullable(),
    parentJobId: IdSchema.nullable(),
    keys: ConcurrencyKeysSchema,
    payload: z.record(z.string(), z.unknown()),
    status: JobStatusSchema,
    attempts: z.number().int().nonnegative(),
    retry: RetryPolicySchema,
    timeoutMs: z.number().int().positive().nullable(),
    /** Last saved checkpoint, handed to the next attempt. */
    checkpoint: z.record(z.string(), z.unknown()).nullable(),
    result: z.record(z.string(), z.unknown()).nullable(),
    /** Why the job failed, for escalation to the owner. */
    diagnosis: z.string().nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const DEFAULT_RETRY = { maxAttempts: 3, backoffMs: 1000, factor: 2 };
//# sourceMappingURL=queue.js.map